<template>
    <div id="contenedor-componente-agregar-programa">
      <v-card
        flat>
        <v-card-text>
          <v-form
            v-model="formularioValido"
            ref="agregarPrograma">
            <v-row
              align="center"
              justify="start">
              <date-picker
                cols="12"
                md="6"
                v-model="programa.fechaInicio"
                label="Fecha Inicio"
                :max="fechaDeTerminoMes"
                :rules="[mixReglas.requerido]">
              </date-picker>
              <date-picker
                cols="12"
                md="6"
                v-model="programa.fechaTermino"
                label="Fecha Termino"
                :min="programa.fechaInicio"
                :max="fechaDeTerminoMes"
                :rules="[mixReglas.requerido]">
              </date-picker>
              <text-field
                cols="12"
                md="6"
                v-model.number="programa.monto"
                label="Monto"
                es-dinero
                prefix="$"
                @keyup.enter.native="agregar"
                :rules="[mixReglas.requerido]">
              </text-field>
              <v-col
                cols="12"
                md="3">
                <v-tooltip
                  top>
                  <template
                    v-slot:activator="{ on, attrs }">
                    <v-btn
                      @click="agregar"
                      :disabled="!formularioValido"
                      icon
                      large
                      color="secondary"
                      v-bind="attrs"
                      v-on="on">
                      <v-icon>
                        mdi-plus
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>Agregar</span>
                </v-tooltip>
                <!-- <v-btn
                  @click="agregar"
                  color="success"
                  :disabled="!formularioValido">
                  <v-icon>
                    mdi-plus
                  </v-icon>
                  agregar
                </v-btn> -->
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
      </v-card>
    </div>
</template>

<script>
import DatePicker from '@/components/inputs/DatePicker.vue';
import TextField from '@/components/inputs/TextField.vue';

export default {
  name: 'ComponenteAgregarPrograma',
  props: {
    fechaInicio: {
      type: String,
      required: false,
      default() {
        const ahora = new Date();
        return `${ahora.getFullYear()}-${(ahora.getMonth() + 1)}-${ahora.getDate()}`;
      },
    },
    fechaTermino: {
      type: String,
      required: false,
    },
  },
  components: {
    DatePicker,
    TextField,
  },
  data() {
    return {
      formularioValido: false,
      fechaDeTerminoMes: '',
      programa: {
        fechaInicio: this.fechaInicio,
        fechaTermino: '',
        plazo: 0,
        monto: 0,
      },
    };
  },
  mounted() {
    this.calcularFechaTermino();
  },
  methods: {
    calcularFechaTermino() {
      if (!this.fechaInicio) return;
      const fechaInicio = new Date(`${this.programa.fechaInicio} 00:00:0`);
      const mesFormatoDosDigitos = (`0${(fechaInicio.getMonth() + 1)}`).slice(-2);

      const diasDelMes = new Date(fechaInicio.getFullYear(), (fechaInicio.getMonth() + 1), 0)
        .getDate();
      const fechaTermino = new Date(`${fechaInicio.getFullYear()}-${mesFormatoDosDigitos}-${diasDelMes} 00:00:0`);

      if (fechaTermino > this.getFechaTerminoContrato) {
        this.fechaDeTerminoMes = this.fechaTermino;
      } else {
        this.fechaDeTerminoMes = `${fechaInicio.getFullYear()}-${mesFormatoDosDigitos}-${diasDelMes}`;
      }

      if (!this.programa.fechaTermino) {
        this.programa.fechaTermino = this.fechaDeTerminoMes;
      }
    },
    calcularPlazo() {
      const fechaInicio = new Date(this.programa.fechaInicio);
      const fechaTermino = new Date(this.programa.fechaTermino);

      // Calcular
      const diferenciaMiliSegundos = Math.abs(fechaTermino - fechaInicio);
      const diferenciaDias = Math.ceil(diferenciaMiliSegundos / (1000 * 60 * 60 * 24));

      this.programa.plazo = (diferenciaDias + 1);
    },
    agregar() {
      this.$emit('seAgrego', this.programa);
    },
  },
  computed: {
    getFechaTerminoContrato() {
      return new Date(`${this.fechaTermino} 00:00:0`);
    },
  },
  watch: {
    programa: {
      handler() {
        this.calcularPlazo();
        this.calcularFechaTermino();
      },
      deep: true,
    },
    fechaInicio: {
      handler() {
        this.calcularFechaTermino();
      },
    },
  },
};
</script>

<style lang="scss">

</style>
